import React from 'react';
import PropTypes from 'prop-types';
import SrLink from 'client/components/SrLink/SrLink';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';

const SrBackLink = ({ to, children }) => (
  <SrBox
    className='SrBackLink greyBlur'
    maxWidth='136px'
    padding='0 14px 0 35px'
    overflow='hidden'
    textOverflow='ellipsis'
    height='40px'
    display='inlineBlock'
    borderRadius='9px'
    backgroundImage='url(/images/arrow-small-nav-left-black.svg)'
    backgroundPosition='14px'
    backgroundRepeat='no-repeat'
  >
    <SrLink to={to}>
      <SrText
        size='large'
        weight='bolder'
        whiteSpace='nowrap'
        lineHeight='40px'
        font='greycliff'
      >
        {children}
      </SrText>
    </SrLink>
  </SrBox>
);

SrBackLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
};

SrBackLink.displayName = 'SrBackLink';

export default SrBackLink;
